import React from 'react'

const Partners = () => {
  return (
    <div>
        <h1>Partners</h1>
    </div>
  )
}

export default Partners